module.exports = __webpack_public_path__ + "static/media/streetBG.bb150ad2.png";